import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'name',
    label: 'Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'status',
    label: 'Status',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'description',
    label: 'Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'cancelationReason',
    label: 'Cancelation Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'submittedText',
    label: 'Submitted Text',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'slaTaskFiles',
    label: 'SLA group task files',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isDocumentRequested',
    label: 'Ordered',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'rejectionReason',
    label: 'Rejection Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const conditionsTaskInfoForm = {
  name: FormNames.CONDITIONS_TASK_INFO,
  label: 'Conditions Task Info',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
